import { useState } from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import StyledModal from '../StyledModal';
import { TextField } from '../../common';
import { incomeParameters } from '../../../utils/api';

export default function MassEditAnimalParametersModal(props) {
  const [value, setValue] = useState(0);

  const handleClose = () => props.setOpen(false);

  const editParameters = () => {
    const body = {
      idList: props.selected,
      incomeValue: value,
    };
    if (props.local) {
      props.setData(
        props.data.map((el) => {
          return props.selected?.includes(el.id)
            ? { ...el, incomeValue: body.incomeValue, edited: true }
            : el;
        })
      );
      handleClose();
    } else
      incomeParameters
        .editAnimalGroupParameters(body)
        .then((res) => {
          props.updateParameters();
          handleClose();
        })
        .catch((err) => {});
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Box>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
              Edytuj masowo zaznaczone wskaźniki
            </Typography>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            sx={{ mt: 3, p: 4 }}
          >
            <TextField
              label="Wartość PLN"
              modalRight
              type="number"
              variant="outlined"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Grid>
          <Grid
            container
            justifyContent="space-evenly"
            sx={{ mt: 2 }}
            columnSpacing={1}
          >
            <Grid item xs={4}>
              <Button variant="outlined" onClick={editParameters}>
                ZAPISZ
              </Button>
            </Grid>
          </Grid>
        </Box>
      </StyledModal>
    </>
  );
}
